export const installations = () => {
  return {
    getId: () => "",
  };
};
